import styled from 'styled-components/macro';

export const Informer = styled.div<{ hasDebt: boolean }>`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${(props) =>
    props.hasDebt
      ? props.theme.colors.red[100]
      : props.theme.colors.green[100]};
  outline: 1px solid
    ${(props) =>
      props.hasDebt
        ? props.theme.colors.red[200]
        : props.theme.colors.green[200]};
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
`;

export const List = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ItemWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border: 1px solid #f2f5f8;
  border-radius: 12px;
`;

export const SectorInfoWrapper = styled.div`
  box-sizing: border-box;
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;
